import {Card} from 'primereact/card';
import { TranslateContext } from '../context/TranslateContext';
import { useContext } from 'react';

export default function NsDashboardCard({
                                            children,
                                            title,
                                            classiAggiuntive = ''
                                        }) {
    const {translate} = useContext(TranslateContext)

    return (
        <Card
            title={translate(title)}
            className={"m-2 " + classiAggiuntive}

        >
            {
                children
            }
        </Card>
    );

}